module.exports = __webpack_public_path__ + "src/assets/img/40.fdc776ce.svg";